import { clearLocalStorage } from '@/utils/localstorage'
import { getRealmId } from '@/utils/realmId'

export function getOidcConfiguration(): any {
  const idpHint = getIdpHint()
  const realmId = getRealmId() ?? 'zdb'
  const realmUrl = window.appConfig.VITE_KEYCLOAK_URL + '/auth/realms/' + realmId
  const sendIdpHint = import.meta.env.VITE_OIDC_IDP_HINT_SEND !== 'false'
  return {
    settings: {
      authority: realmUrl,
      automaticSilentRenew: true,
      automaticSilentSignin: true,
      client_id: 'frontend',
      postLogoutRedirectUri: window.location.origin,
      redirect_uri: window.location.origin + `/oauth2`,
      responseType: 'code',
      scope: 'openid roles',
      silentRedirectUri: window.location.origin + '/silentrenew',
      extraQueryParams: sendIdpHint
        ? {
            kc_idp_hint: idpHint
          }
        : undefined
    },
    optionalSettings: {},
    optionalEvents: {
      accessTokenExpired: () => {
        console.log('Access token expired, signing out')
        clearLocalStorage()
        window.location.replace(window.location.origin + `/oauth2`)
      }
    }
  }
}

function getIdpHint(): string | undefined {
  const internalZynkaUser = localStorage.getItem('internalZynkaUser')
  return internalZynkaUser ? 'digital-buildings' : undefined
}

export function getRealmFromSubDomain(): string | null {
  if (window.location.host.endsWith('digitalbuildings.ai'))
    return window.location.host.split('.')[0]

  return null
}
